module.exports = __webpack_public_path__ + "img/tab-image-dancing-shopAvatar.785114cd.png";